const Divider = () => <hr className="border border-solid border-[#00000014]" />;

export default Divider;
